import React from 'react'
import { useTranslation } from 'react-i18next'
import BaseButton from '../../components/buttons/BaseButton'
import { useCapabilitiesStore } from '../../stores/capabilitiesStore'
import LoadingLayoutWrapper from '../../components/LoadingLayoutWrapper'
import { useTheme } from '../../contexts/themeContext'
import { Typography } from '../../components/styled'

function PermissionsLoad({ children }) {
  const { t } = useTranslation()
  const { theme } = useTheme()
  const ensureLoaded = useCapabilitiesStore((s) => s.ensureLoaded)
  const loaded = useCapabilitiesStore((s) => s.loaded)
  const errorCode = useCapabilitiesStore((s) => s.errorCode)

  React.useEffect(() => {
    ensureLoaded()
  }, [ensureLoaded])

  if (errorCode) {
    return (
      <div className="d-flex flex-column align-items-center justify-content-center vh-100" style={{ gap: '24px' }}>
        <Typography size="18px" color={theme.inputField}>
          {t('errorBoundary.defaultError')}
        </Typography>
        <BaseButton
          backgroundcolor={theme.brandColorOrange}
          hoverbackgroundcolor={theme.brandColorLightOrange}
          color={theme.white}
          onClick={() => window.location.reload()}
          style={{ borderRadius: '4px', padding: '8px 24px' }}
        >
          {t('errorBoundary.retryButton')}
        </BaseButton>
      </div>
    )
  }

  if (!loaded) return <LoadingLayoutWrapper />
  return children
}

export default PermissionsLoad
